"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NAME_SELECTOR = 'data-findify-filter';
var VALUE_SELECTOR = 'data-findify-filter-value';
var TYPE_SELECTOR = 'data-findify-filter-type';
exports.getFiltersOnPage = function (root) {
    return Array.prototype.slice
        .call(root.querySelectorAll("[data-findify-filter]"))
        .map(function (node) {
        var name = node.getAttribute(NAME_SELECTOR);
        var value = node.getAttribute(VALUE_SELECTOR);
        var type = node.getAttribute(TYPE_SELECTOR);
        var values = void 0;
        try {
            if (!isNaN(Number(value)))
                throw new Error();
            values = JSON.parse(value);
        }
        catch (e) {
            values = [{ value: value.split(/,|>/).map(function (v) { return v && v.trim(); }) }];
        }
        return { name: name, values: values, type: type || undefined };
    })
        .filter(function (i) { return !!i; });
};
//# sourceMappingURL=filters.js.map